import http from 'services/http';

export async function showExport(id: string) {
  return http.get<{ id: string; url: string }>(`/exports/${id}`).then((res) => res.data);
}
